import React, { useEffect, useState } from 'react';
import tw from 'twin.macro';
import styled, { css } from 'styled-components';
import { useI18n } from '@whizz/react-i18n';
import Whizzy from '../animation/Whizzy';

interface TooltipProps {
  position?: 'top' | 'bottom' | 'left';
}

const TooltipStyled = styled.div`
  margin: 1rem;
`;
const TooltipStyledContent = styled.h2<TooltipProps>`
  position: relative;
  background: white;
  color: #000;
  line-height: normal;
  border-radius: 0.5rem;
  padding: 1.6rem;
  text-align: center;
  box-shadow: ${(props) => props.theme.shadows.md};
  font-size: 1.5rem;
  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 0;
    z-index: 1;
    border-style: solid;
    ${(props) => {
    switch (props.position) {
      case 'top':
        return css`
          border-width: 3rem 0 0 4rem;
          border-color: transparent transparent transparent #FFFFFF;
          top: -3rem;
          left: 50%;
          margin-left: -1rem;`;
      case 'bottom':
        return css`
          border-width: 3rem 4rem 0 0;
          border-color: #FFFFFF transparent transparent transparent;
          bottom: -3rem;
          left: 50%;
          margin-left: -1rem;`;
      default:
        return css`
          border-width: 0 2rem 2rem 0;
          border-color: transparent #FFFFFF transparent transparent;
          top: 50%;
          left: -2rem;
          margin-top: -1rem;`;
    }
  }}
  }    
`;

const WhizzyStyled = styled(Whizzy)`
  position: relative;
  transform: rotate(-5deg);
  width: 40rem;
  ${tw`m-[-3rem] lg:order-first lg:m-[-8rem]`}
`;

const WhizzyLoader = ({ show = true }: { show?: boolean }): JSX.Element => {
  const { translate } = useI18n();
  const [ message, setMessage ] = useState('');

  useEffect(() => {
    setMessage('components.LOADERS.WHIZZY.MESSAGE_1');
    const timerId = setTimeout(() => setMessage('components.LOADERS.WHIZZY.MESSAGE_2'), 10000);
    return () => clearTimeout(timerId);
  }, [ show ]);

  const isLg = window.matchMedia('(min-width: 1024px)').matches;
  return (
    <div className={`left-0 relative flex flex-col justify-center items-center z-[10000] m-4 mt-lg lg:flex-row ${!show ? 'hidden' : ''}`}>
      <TooltipStyled>
        <TooltipStyledContent position={isLg ? 'left' : 'bottom'}>{translate(message)}</TooltipStyledContent>
      </TooltipStyled>
      <WhizzyStyled animation={'congratulations'} />
    </div>


  );
};

WhizzyLoader.defaultName = 'WhizzyLoader';

export default WhizzyLoader;
